module.exports = __webpack_public_path__ + "img/badge-8k-fill.8825a142.svg";